import React from 'react';
import { getIndianRupeeNotation } from '../../app_methods';
import { Typography } from 'antd';


const EaseCurrency = (props) => {
    const SIZES = {
        xs: [12, 4],
        s: [16, 8],
        m: [20, 12],
        l: [24, 16],
        xl: [28, 20]
    };

    const renderPrefix = () => {
        return props.prefix ? <Typography.Text style={{ color: props.color || "#000000d9" }}>{props.prefix}</Typography.Text> : null;
    };

    const renderCurrency = () => {
        const indianNotation = getIndianRupeeNotation(props.amount, props.precision);
        return (
            <span>
                <Typography.Text style={{ color: props.color || "#000000d9", fontSize: SIZES[props.size][0] }}>{indianNotation.integer}</Typography.Text>
                {
                    props.precision ?
                        <Typography.Text style={{ color: props.color || "#000000d9", fontSize: SIZES[props.size][1] }}>.{indianNotation.decimal}</Typography.Text>
                        :
                        null
                }
            </span>
        )
    };
    const renderSuffix = () => {
        return props.suffix ? <Typography.Text style={{ color: props.color || "#000000d9" }}>{props.suffix}</Typography.Text> : null;
    };

    return (
        <div>{renderPrefix()} {renderCurrency()} {renderSuffix()}</div>
    )
};

EaseCurrency.defaultProps = {
    size: "m",
    amount: 0.00,
    precision: 2,
    prefix: null,
    suffix: null
}

export { EaseCurrency };